import type { ReactNode } from "react";

import { cn } from "@/utils/cn";

// Figma: https://www.figma.com/design/HJIp5P6tyeFrUd7ODqeWdM/-PROD--Fertility-V?node-id=4202-7058

export const SECTION_HEADER_ALIGNS = ["start", "center"] as const;

export type SectionHeaderAlign = (typeof SECTION_HEADER_ALIGNS)[number];

type SectionHeaderProps = {
  /** The heading. Wrap the emphasized words in `<em>` for Marist Book Italic. */
  title: ReactNode;
  /** Uppercase line above the heading. */
  eyebrow?: ReactNode;
  /** Body copy below the heading. */
  children?: ReactNode;
  /** A CTA below the body. */
  action?: ReactNode;
  align?: SectionHeaderAlign;
  /** Layout only. A repeated look is a variant. */
  className?: string;
};

const ALIGNS: Record<SectionHeaderAlign, string> = {
  start: "items-start text-left",
  center: "items-center text-center",
};

// m-0 clears the global heading and paragraph margins from base.css.
// Display component, no ref forwarded. See ui/README.md.
export const SectionHeader = ({
  title,
  eyebrow,
  children,
  action,
  align = "start",
  className,
}: SectionHeaderProps) => (
  <div
    className={cn(
      "flex flex-col gap-ds-space-03 text-ds-text-primary",
      ALIGNS[align],
      className
    )}
  >
    {eyebrow && <p className="m-0 ds-header-subheader">{eyebrow}</p>}
    <h2 className="m-0 ds-header-h2">{title}</h2>
    {children && <div className="ds-body-base-regular">{children}</div>}
    {action && <div className="pt-ds-space-03">{action}</div>}
  </div>
);
